module.exports = __webpack_public_path__ + "img/20191016163346906.92e72f3a.jpg";